import { render } from "./Voip.vue?vue&type=template&id=3670b659"
import script from "./Voip.vue?vue&type=script&lang=js"
export * from "./Voip.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__